import React from "react";

import { get } from "lodash";
import cx from "classnames";

import Icons from "../../icons";
import { ICONS } from "../../../constants/icons.constants";
import disLikedSongsStore from "../../../zustand/dislikedSong.store";
import { songActions } from "../../../actions";

import styles from "./dislike.module.scss";
import userStore from "../../../zustand/user.store";
import likedSongsStore from "../../../zustand/likedSong.store";

const Dislike = ({ row }) => {
  const { songs: dislikedSongs, setDislikeToSong } = disLikedSongsStore();
  const { removeLikeFromSong } = likedSongsStore();
  const { userOffline } = userStore((state) => ({
    userOffline: state.userOffline,
  }));

  const id = get(row, "id", "");

  const handleThumbDownClick = async (e) => {
    e.stopPropagation();
    setDislikeToSong(id);
    removeLikeFromSong(id);

    const isSuccess = await songActions.addReactionToSong(
      id,
      "DISLIKE",
      userOffline
    );

    if (!isSuccess) {
      setDislikeToSong(id);
      removeLikeFromSong(id);
    }
  };

  return (
    <div onClick={handleThumbDownClick} className={cx(styles.column3)}>
      {!get(dislikedSongs, id, false) ? (
        <Icons type={ICONS.THUMBS_DOWN} />
      ) : (
        <Icons type={ICONS.THUMBS_DOWN_FILLED} />
      )}
    </div>
  );
};

export default Dislike;
